import { NgModule } from '@angular/core'
import { QuickAddToCartComponent } from './quick-add-to-cart.component'
import { provideConfig } from '@spartacus/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap'
import { MbI18nModule } from '../../../translations/mb-i18n.module'

const declarations = [
  QuickAddToCartComponent
]

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MbI18nModule,
    NgbTypeaheadModule,
  ],
  declarations,
  exports: declarations,
  providers: [
    provideConfig({
      cmsComponents: {
        QuickAddToCartComponent: {
          component: QuickAddToCartComponent
        }
      }
    })
  ]
})
export class QuickAddToCartModule {
}
